import React, {Component, Fragment} from "react";
import {getModalData, getUserPermission} from "../../../selectors";
import {hideModal, showModal} from "../../../actions/modal.actions";
import {connect} from "react-redux";
import {loadBillingJob, loadBillingJobStatusSummary, loadBillingJobStatusDetails, loadBillingJobAssessment} from "../../../actions/billingJobs.actions";
import Button from "../../../components/Common/Buttons/Button";
import moment from "moment";

class BillingJobMonitorModal extends Component {
    state = {
        billingJob: null,
        billingJobDetail: null,
        statusDetails: null,
        refreshInterval: 0,
        pauseRefresh: false,
        testBillingJobLogDisplayed: false,
        billingApprovalJobLogDisplayed: false,
        invoiceGenerationJobLogDisplayed: false,
        testBillingLogMessagesResponse: null,
        billingApprovalLogMessagesResponse: null,
        invoiceGenerationLogMessagesResponse: null,
        copiedSection: null,
        rejectClicked: false,
        assessment: null,
        assessmentLoading: false,
        assessmentExpanded: false,
    }

    componentDidMount() {
        const {
            billingJob
        } = this.props.modalProps;

        const isFinalState = billingJob.status === 'BILLING_FAILED' || billingJob.status === 'TESTBILLING_REJECTED' || billingJob.status === 'TESTBILLING_CANCELED';

        this.props.loadBillingJob(billingJob.id).then(detail => {
            this.setState({ billingJobDetail: detail });
        });

        this.props.loadBillingJobAssessment(billingJob.id).then(data => {
            if (data && data.status) {
                this.setState({ assessment: data });
            }
        });

        this.props.loadBillingJobStatusSummary(billingJob.id).then(response => {
            this.setState(() => ({
                statusDetails: response,
            }));
            if (isFinalState ||
                ((response.testBillingTotalToComplete > 0) &&
                (response.testBillingNumCompleted === response.testBillingTotalToComplete) &&
                (response.billingApprovalTotalToComplete > 0) &&
                (response.billingApprovalNumCompleted === response.billingApprovalTotalToComplete) &&
                (response.invoiceGenerationTotalToComplete > 0) &&
                (response.invoiceGenerationNumCompleted === response.invoiceGenerationTotalToComplete))) {
                this.setState({refreshInterval: 0});
            } else {
                this.setState({refreshInterval: 15000});
                this.setTimer();
            }
        });
    }

    componentWillUnmount() {
        this.setState({refreshInterval: 0, pauseRefresh: true});
        this.clearTimer();
    }

    setTimer = () => {
        if (this.timerHandle) {
            return;
        }
        // Remember the timer handle
        this.timerHandle = setTimeout(() => {
            this.refreshBillingJobDetails();
            this.timerHandle = 0;
        }, this.state.refreshInterval);
    };

    clearTimer = () => {
        if (this.timerHandle) {
            clearTimeout(this.timerHandle);
            this.timerHandle = 0;
        }
    };

    closeModal = () => {
        this.props.hideModal();
    };

    handleGenerateInvoices = () => {
        const { billingJob } = this.props.modalProps;
        this.props.showModal('BILLING_JOB_GENERATE_MODAL', { billingJob, onCloseCallback: this.reopenMonitorModal });
    };

    handleCopyLogs = (section, logResponse) => {
        const text = logResponse.statusList.map(log => log.stringVal).join('\n');
        navigator.clipboard.writeText(text).then(() => {
            this.setState({ copiedSection: section });
            setTimeout(() => this.setState({ copiedSection: null }), 2000);
        });
    };

    reopenMonitorModal = () => {
        const { billingJob, canGenerateInvoices, canRejectBilling, canApproveBilling } = this.props.modalProps;
        this.props.showModal('BILLING_JOB_MONITOR_MODAL', { billingJob, canGenerateInvoices, canRejectBilling, canApproveBilling });
    };

    handleRejectBilling = () => {
        if (this.state.rejectClicked) return;
        this.setState({ rejectClicked: true });
        const { billingJob } = this.props.modalProps;
        this.props.showModal('BILLING_JOB_REJECT_MODAL', { billingJob, onCloseCallback: this.reopenMonitorModal });
    };

    handleApproveBilling = () => {
        const { billingJob } = this.props.modalProps;
        this.props.showModal('BILLING_JOB_APPROVE_MODAL', { billingJob, onCloseCallback: this.reopenMonitorModal });
    };

    handleShowBillingJobLog = (e) => {
        const {
            billingJob
        } = this.props.modalProps;
        const {
            refreshInterval,
            testBillingJobLogDisplayed,
            billingApprovalJobLogDisplayed,
            invoiceGenerationJobLogDisplayed
        } = this.state;

        let billingStep = null;
        if ((e.target.id === "testBillingLogDisplaySelector") || ((e.target.className !== undefined) && (e.target.className.includes("btn-test-billing-log-display")))) {
            if (!this.state.testBillingJobLogDisplayed) {
                // If the current state is false that means we selected to display the log messages and the fetch needs to occur
                billingStep = "testBilling";
            }
            this.setState({testBillingJobLogDisplayed: !this.state.testBillingJobLogDisplayed,});
        } else if ((e.target.id === "billingApprovalLogDisplaySelector") || ((e.target.className !== undefined) && (e.target.className.includes("btn-billing-approval-log-display")))) {
            if (!this.state.billingApprovalJobLogDisplayed) {
                billingStep = "billingApproval";
            }
            this.setState({billingApprovalJobLogDisplayed: !this.state.billingApprovalJobLogDisplayed,});
        } else if ((e.target.id === "invoiceGenerationLogDisplaySelector") || ((e.target.className !== undefined) && (e.target.className.includes("btn-invoice-generation-log-display")))) {
            if (!this.state.invoiceGenerationJobLogDisplayed) {
                billingStep = "invoiceGeneration";
            }
            this.setState({invoiceGenerationJobLogDisplayed: !this.state.invoiceGenerationJobLogDisplayed,});
        }
        setTimeout(() => {
            const {
                testBillingJobLogDisplayed,
                billingApprovalJobLogDisplayed,
                invoiceGenerationJobLogDisplayed
            } = this.state;

            if (billingStep != null) {
                this.props.loadBillingJobStatusDetails(billingJob.id, billingStep).then(response => {
                    if (billingStep === "testBilling") {
                        this.setState(() => ({testBillingLogMessagesResponse: response,}));
                    } else if (billingStep === "billingApproval") {
                        this.setState(() => ({billingApprovalLogMessagesResponse: response,}));
                    } else if (billingStep === "invoiceGeneration") {
                        this.setState(() => ({invoiceGenerationLogMessagesResponse: response,}));
                    }
                    if ((response.testBillingTotalToComplete > 0) &&
                        (response.testBillingNumCompleted === response.testBillingTotalToComplete) &&
                        (response.billingApprovalTotalToComplete > 0) &&
                        (response.billingApprovalNumCompleted === response.billingApprovalTotalToComplete) &&
                        (response.invoiceGenerationTotalToComplete > 0) &&
                        (response.invoiceGenerationNumCompleted === response.invoiceGenerationTotalToComplete)) {
                        this.setState({refreshInterval: 0});
                    } else {
                        if (refreshInterval > 0) {
                            this.setTimer();
                        }
                    }
                });
            }

            this.manageAutoRefresh((!(this.state.testBillingJobLogDisplayed || this.state.billingApprovalJobLogDisplayed || this.state.invoiceGenerationJobLogDisplayed)));
        }, 50);
    }

    manageAutoRefresh = (turnRefreshOn) => {
        if (turnRefreshOn) {
            this.setState({refreshInterval: 15000, pauseRefresh:false});
            this.refreshBillingJobDetails();
        } else {
            this.setState({refreshInterval: 0, pauseRefresh:true});
        }
    }

    refreshBillingJobDetails = () => {
        const {
            billingJob
        } = this.props.modalProps;
        const {
            pauseRefresh,
            refreshInterval,
        } = this.state;

        if (pauseRefresh) {
            return;
        }
        this.props.loadBillingJob(billingJob.id).then(detail => {
            this.setState({ billingJobDetail: detail });
        });
        if (!this.state.assessment || this.state.assessment.status === 'ANALYZING') {
            this.props.loadBillingJobAssessment(billingJob.id).then(data => {
                if (data && data.status) {
                    this.setState({ assessment: data });
                }
            });
        }
        this.props.loadBillingJobStatusSummary(billingJob.id).then(response => {
            this.setState(() => ({
                statusDetails: response,
            }));
            if ((response.testBillingTotalToComplete > 0) &&
                (response.testBillingNumCompleted === response.testBillingTotalToComplete) &&
                (response.billingApprovalTotalToComplete > 0) &&
                (response.billingApprovalNumCompleted === response.billingApprovalTotalToComplete) &&
                (response.invoiceGenerationTotalToComplete > 0) &&
                (response.invoiceGenerationNumCompleted === response.invoiceGenerationTotalToComplete)) {
                this.setState({refreshInterval: 0});
            } else {
                if (refreshInterval > 0) {
                    this.setTimer();
                }
            }
        });
    }

    formatAssessmentDetails = (text) => {
        if (!text) return null;
        let data;
        if (typeof text === 'object' && text !== null) {
            data = text;
        } else if (typeof text === 'string') {
            // Sanitize: collapse raw newlines + surrounding whitespace inside the JSON string
            const sanitized = text.replace(/\s*\n\s*/g, ' ').trim();
            try {
                data = JSON.parse(sanitized);
            } catch (e) {
                return <p className="mb-1" style={{fontSize: '0.85rem'}}>{text}</p>;
            }
        } else {
            return null;
        }
        if (!data || !data.sections) {
            return <p className="mb-1" style={{fontSize: '0.85rem'}}>{typeof text === 'string' ? text : JSON.stringify(text)}</p>;
        }

        const elements = [];
        let key = 0;

        // Render sections
        if (data.sections) {
            data.sections.forEach((section) => {
                // Section title
                elements.push(
                    <h6 key={key++} className="font-weight-bold mt-3 mb-1" style={{fontSize: '0.95rem', letterSpacing: '0.05em', color: '#764ba2', borderBottom: '2px solid #764ba2', paddingBottom: '4px'}}>
                        {section.title}
                    </h6>
                );

                // Section description
                if (section.description) {
                    elements.push(<p key={key++} className="mb-2" style={{fontSize: '0.85rem'}}>{section.description}</p>);
                }

                // Comparison (CURRENT / PREVIOUS)
                if (section.comparison) {
                    elements.push(
                        <div key={key++} className="mb-2">
                            <div className="d-flex align-items-center mb-1" style={{fontSize: '0.85rem', fontFamily: 'monospace'}}>
                                <span className="badge badge-primary mr-2" style={{fontSize: '0.7rem', minWidth: '80px', textAlign: 'center'}}>CURRENT</span>
                                <span>{section.comparison.current}</span>
                            </div>
                            <div className="d-flex align-items-center mb-1" style={{fontSize: '0.85rem', fontFamily: 'monospace'}}>
                                <span className="badge badge-secondary mr-2" style={{fontSize: '0.7rem', minWidth: '80px', textAlign: 'center'}}>PREVIOUS</span>
                                <span>{section.comparison.previous}</span>
                            </div>
                        </div>
                    );
                }

                // Metrics
                if (section.metrics && section.metrics.length > 0) {
                    section.metrics.forEach((metric) => {
                        elements.push(
                            <div key={key++} className="d-flex mb-1 px-2" style={{fontSize: '0.85rem'}}>
                                <span className="text-muted mr-2">{metric.label}</span>
                                <span className="font-weight-bold">{metric.value}</span>
                            </div>
                        );
                    });
                }

                // Legend
                if (section.legend && section.legend.length > 0) {
                    elements.push(
                        <div key={key++} className="mb-2 mt-1">
                            {section.legend.map((item, idx) => (
                                <div key={idx} className="mb-0 px-2" style={{fontSize: '0.82rem'}}>
                                    <strong className="mr-1">{item.key}</strong>
                                    <span className="text-muted">= {item.definition}</span>
                                </div>
                            ))}
                        </div>
                    );
                }

                // Checks
                if (section.checks && section.checks.length > 0) {
                    elements.push(
                        <div key={key++} className="mb-2">
                            {section.checks.map((check, idx) => (
                                <div key={idx} className="mb-0 px-2" style={{fontSize: '0.82rem'}}>
                                    <strong className="mr-1">Check {check.id}</strong>
                                    <span className="text-muted">— {check.description}</span>
                                </div>
                            ))}
                        </div>
                    );
                }

                // Flags
                if (section.flags && section.flags.length > 0) {
                    section.flags.forEach((flag) => {
                        elements.push(
                            <div key={key++} className="mb-2 mt-2 p-2 rounded" style={{backgroundColor: '#fff3cd', border: '1px solid #ffc107', fontSize: '0.85rem'}}>
                                <div>
                                    <strong style={{color: '#856404'}}><i className="fa fa-flag mr-1"/>{flag.name}</strong>
                                </div>
                                {flag.meta && <div className="text-muted" style={{fontSize: '0.8rem'}}>{flag.meta}</div>}
                                {flag.explanation && <div className="mt-1" style={{fontSize: '0.83rem'}}>{flag.explanation}</div>}
                            </div>
                        );
                    });
                }
            });
        }

        // Recommendation & Justification
        if (data.recommendation) {
            elements.push(
                <div key={key++} className="d-flex align-items-start mt-3 mb-1">
                    <strong className="mr-2" style={{minWidth: '120px', fontSize: '0.85rem'}}>Recommendation:</strong>
                    <span style={{fontSize: '0.85rem'}}>{data.recommendation}</span>
                </div>
            );
        }
        if (data.justification) {
            elements.push(
                <div key={key++} className="d-flex align-items-start mt-1 mb-1">
                    <strong className="mr-2" style={{minWidth: '120px', fontSize: '0.85rem'}}>Justification:</strong>
                    <span style={{fontSize: '0.85rem'}}>{data.justification}</span>
                </div>
            );
        }

        return elements;
    };

    getAssessmentStatusBadge = (assessment) => {
        if (!assessment) return null;
        const { status, validationResult } = assessment;

        if (status === 'ANALYZING') {
            return (
                <span className="badge badge-pill text-dark" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600', backgroundColor: '#e0e0e0'}}>
                    <i className="fa fa-circle-notch fa-spin mr-1"/>Analyzing
                </span>
            );
        }
        if (status === 'COMPLETED' && validationResult && validationResult.toUpperCase().includes('APPROVE')) {
            return (
                <span className="badge badge-pill badge-success text-white" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600'}}>
                    <i className="fa fa-check mr-1"/>{validationResult.replace(/_/g, ' ')}
                </span>
            );
        }
        if (status === 'COMPLETED' && validationResult && validationResult.toUpperCase().includes('REJECT')) {
            return (
                <span className="badge badge-pill badge-danger text-white" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600'}}>
                    <i className="fa fa-times mr-1"/>{validationResult.replace(/_/g, ' ')}
                </span>
            );
        }
        if (status === 'COMPLETED') {
            return (
                <span className="badge badge-pill badge-success text-white" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600'}}>
                    <i className="fa fa-check mr-1"/>Completed
                </span>
            );
        }
        return null;
    };

    render() {
        const {
            statusDetails,
            billingJobDetail,
            refreshInterval: _refreshInterval,
            testBillingJobLogDisplayed,
            billingApprovalJobLogDisplayed,
            invoiceGenerationJobLogDisplayed,
            testBillingLogMessagesResponse,
            billingApprovalLogMessagesResponse,
            invoiceGenerationLogMessagesResponse,
            copiedSection,
            assessment,
            assessmentLoading,
        } = this.state;

        const refreshInterval = _refreshInterval;
        const { billingJob: originalBillingJob } = this.props.modalProps;
        const billingJob = billingJobDetail ? { ...originalBillingJob, ...billingJobDetail } : originalBillingJob;
        const { canGenerateInvoices, canRejectBilling, canApproveBilling } = this.props;

        return (
            <Fragment>
                <div className="modal" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Billing Progress</h5>
                                <button type="button" className="close" onClick={this.closeModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="order-service-order-wrapper mb-3">
                                    <div className="mb-1">
                                        <h5 className="mb-0 font-weight-bold d-flex align-items-center">
                                            Billing Job
                                            <span className="badge badge-pill badge-light border ml-2 font-weight-normal" style={{fontSize: '0.85rem'}}>
                                                #{billingJob.id}
                                            </span>
                                        </h5>
                                        {billingJob.invoiceDate && (
                                            <small className="text-muted">
                                                <i className="fa fa-calendar-alt mr-1"/>
                                                Invoice Date: {moment(billingJob.invoiceDate).format('MM/DD/YYYY')}
                                            </small>
                                        )}
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between flex-wrap mt-1" style={{gap: '0.5rem'}}>
                                        <div>
                                            {refreshInterval > 0 &&
                                                <small className="text-muted"><i className="fa fa-sync-alt fa-spin mr-1"/>Refreshing every {refreshInterval/1000}s</small>
                                            }
                                            {refreshInterval === 0 &&
                                                <span className={`badge badge-pill ${billingJob.status === 'BILLING_FAILED' ? 'badge-danger' : billingJob.status === 'TESTBILLING_REJECTED' ? 'badge-secondary' : 'badge-success'} text-white`} style={{fontSize: '0.85rem', padding: '5px 12px', letterSpacing: '0.03em', fontWeight: '600'}}>
                                                    <i className={`fa ${billingJob.status === 'BILLING_FAILED' ? 'fa-times' : billingJob.status === 'TESTBILLING_REJECTED' ? 'fa-ban' : 'fa-check'} mr-1`}/>
                                                    {billingJob.status === 'TESTBILLING_FINISHED' ? 'Test Billing Finished'
                                                        : billingJob.status === 'TESTBILLING_REJECTED' ? 'Test Billing Rejected'
                                                        : billingJob.status === 'APPROVEBILLING_FINISHED' ? 'Approve Billing Finished'
                                                        : billingJob.status === 'BILLING_FAILED' ? 'Billing Failed'
                                                        : 'Job Completed'}
                                                </span>
                                            }
                                        </div>
                                        <div className="d-flex flex-nowrap" style={{gap: '0.5rem'}}>
                                            {billingJobDetail && canApproveBilling && billingJob.status === 'TESTBILLING_FINISHED' && !(billingJobDetail.generateScheduled != null && billingJobDetail.generateFinished == null) && (
                                                <Button onClick={this.handleApproveBilling} className="btn btn-sm btn-success text-white rounded-pill" style={{whiteSpace: 'nowrap'}} type="button">
                                                    <i className="fas fa-user-check mr-1" />Approve<span className="d-none d-sm-inline"> Billing</span>
                                                </Button>
                                            )}
                                            {billingJobDetail && canGenerateInvoices && (billingJob.status === 'TESTBILLING_FINISHED' || billingJob.status === 'APPROVEBILLING_FINISHED') && !(billingJobDetail.generateScheduled != null && billingJobDetail.generateFinished == null) && !(statusDetails && statusDetails.invoiceGenerationLastMessage != null && statusDetails.invoiceGenerationTotalToComplete > 0 && statusDetails.invoiceGenerationNumCompleted < statusDetails.invoiceGenerationTotalToComplete) && (
                                                <Button onClick={this.handleGenerateInvoices} className="btn btn-sm btn-primary rounded-pill" style={{whiteSpace: 'nowrap'}} type="button">
                                                    <i className="fa fa-file-invoice mr-1" />Generate Invoices
                                                </Button>
                                            )}
                                            {billingJobDetail && canRejectBilling && billingJob.status === 'TESTBILLING_FINISHED' && !(billingJobDetail.generateScheduled != null && billingJobDetail.generateFinished == null) && (
                                                <Button onClick={this.handleRejectBilling} className="btn btn-sm btn-danger rounded-pill" style={{whiteSpace: 'nowrap'}} type="button">
                                                    <i className="fas fa-user-times mr-1" />Reject<span className="d-none d-sm-inline"> Billing</span>
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {assessment && (
                                    <div className="card mb-3">
                                        <div
                                            className="card-header text-white d-flex align-items-center justify-content-between"
                                            style={{background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', cursor: 'pointer'}}
                                            onClick={() => this.setState(prev => ({assessmentExpanded: !prev.assessmentExpanded}))}
                                        >
                                            <h6 className="mb-0">
                                                <i className={`fas fa-chevron-${this.state.assessmentExpanded ? 'down' : 'right'} mr-2`} style={{fontSize: '0.75rem', width: '12px'}}/>
                                                <i className="fas fa-magic mr-2"/>
                                                AI Billing Analytics
                                            </h6>
                                        </div>
                                        {this.state.assessmentExpanded && <div className="card-body">
                                            {assessment.status === 'ANALYZING' && (
                                                <div className="text-center py-3">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="sr-only">Analyzing...</span>
                                                    </div>
                                                    <p className="mt-2 mb-0 text-muted">
                                                        <i className="fas fa-magic mr-1"/>
                                                        AI is analyzing billing data...
                                                    </p>
                                                    <small className="text-muted">
                                                        Started {moment(assessment.createdDatetime).fromNow()}
                                                    </small>
                                                </div>
                                            )}

                                            {assessment.status === 'COMPLETED' && (
                                                <div>
                                                    <div className="d-flex flex-wrap mb-2" style={{gap: '1rem'}}>
                                                        <div>
                                                            <small className="text-muted">Generated:</small>
                                                            <div style={{fontSize: '0.85rem'}}>
                                                                {moment(assessment.createdDatetime).format('MM/DD/YYYY hh:mm A')}
                                                            </div>
                                                        </div>
                                                        {assessment.validationResult && (
                                                            <div>
                                                                <small className="text-muted">Validation Result:</small>
                                                                <div style={{fontSize: '0.85rem'}}>
                                                                    <strong className={assessment.validationResult.toUpperCase().includes('APPROVE') ? 'text-success' : 'text-danger'}>
                                                                        {assessment.validationResult}
                                                                    </strong>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {assessment.details && (
                                                        <>
                                                            <hr className="my-2"/>
                                                            <div style={{fontSize: '0.9rem', lineHeight: '1.6'}}>
                                                                {this.formatAssessmentDetails(assessment.details)}
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            )}
                                        </div>}
                                    </div>
                                )}

                                <div className="border rounded p-3 mb-3">
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <div className="d-flex align-items-center" style={{gap: '0.5rem'}}>
                                            <h6 className="mb-0 font-weight-bold">Test Billing</h6>
                                            {statusDetails != null && statusDetails.testBillingTotalToComplete > 0 && statusDetails.testBillingNumCompleted === statusDetails.testBillingTotalToComplete && billingJob.status !== 'TESTBILLING_STARTED' && billingJob.status !== 'APPROVEBILLING_STARTED' &&
                                                <span className="badge badge-pill badge-success text-white" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600'}}><i className="fa fa-check mr-1"/>Completed</span>
                                            }
                                            {statusDetails != null && statusDetails.testBillingLastMessage == null && billingJob.status === 'TESTBILLING_SCHEDULED' &&
                                                <span className="badge badge-pill badge-primary text-white" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600'}}><i className="fa fa-calendar-alt mr-1"/>Scheduled</span>
                                            }
                                            {statusDetails != null && (billingJob.status === 'TESTBILLING_STARTED' || billingJob.status === 'APPROVEBILLING_STARTED') &&
                                                <span className="badge badge-pill text-dark" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600', backgroundColor: '#e0e0e0'}}><i className="fa fa-circle-notch fa-spin mr-1"/>In Progress</span>
                                            }
                                            {statusDetails != null && statusDetails.testBillingLastMessage != null && !(statusDetails.testBillingTotalToComplete > 0 && statusDetails.testBillingNumCompleted === statusDetails.testBillingTotalToComplete) && billingJob.status !== 'BILLING_FAILED' && billingJob.status !== 'TESTBILLING_STARTED' && billingJob.status !== 'APPROVEBILLING_STARTED' &&
                                                <span className="badge badge-pill text-dark" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600', backgroundColor: '#e0e0e0'}}><i className="fa fa-circle-notch fa-spin mr-1"/>In Progress</span>
                                            }
                                            {statusDetails != null && statusDetails.testBillingLastMessage != null && !(statusDetails.testBillingTotalToComplete > 0 && statusDetails.testBillingNumCompleted === statusDetails.testBillingTotalToComplete) && billingJob.status === 'BILLING_FAILED' &&
                                                <span className="badge badge-pill badge-danger text-white" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600'}}><i className="fa fa-times mr-1"/>Failed</span>
                                            }
                                        </div>
                                        <div className="d-flex align-items-center" style={{gap: '0.25rem'}}>
                                            {statusDetails != null && statusDetails.testBillingLastMessage != null &&
                                                <span title={testBillingJobLogDisplayed ? "Hide Test Billing Log" : "Show Test Billing Log"}>
                                                    <Button onClick={this.handleShowBillingJobLog} className="btn btn-xs btn-order-log-toggle btn-test-billing-log-display" onMouseLeave={(e) => e.currentTarget.blur()} type="button">
                                                        <i id="testBillingLogDisplaySelector" className="fas fa-list-ul"/>
                                                    </Button>
                                                </span>
                                            }
                                        </div>
                                    </div>
                                    {statusDetails == null &&
                                        <span className="badge badge-pill badge-light border text-muted">Not Started</span>
                                    }
                                    {statusDetails != null &&
                                        <>
                                            <p className="text-muted small mb-2">
                                                {statusDetails.testBillingLastMessage != null ? statusDetails.testBillingLastMessage : 'Not Started'}
                                            </p>
                                            {statusDetails.testBillingLastMessage != null &&
                                                <>
                                                    <div className="progress rounded-pill mb-1" style={{height: '18px', position: 'relative', ...(billingJob.status === 'BILLING_FAILED' && !(statusDetails.testBillingTotalToComplete > 0 && statusDetails.testBillingNumCompleted === statusDetails.testBillingTotalToComplete) && {backgroundColor: '#bd2130'})}}>
                                                        {(() => { const failed = billingJob.status === 'BILLING_FAILED' && statusDetails.testBillingLastMessage != null && !(statusDetails.testBillingTotalToComplete > 0 && statusDetails.testBillingNumCompleted === statusDetails.testBillingTotalToComplete); return (
                                                        <div className={`progress-bar ${failed ? 'bg-danger' : 'bg-success-with-pulse'}`} role="progressbar"
                                                             style={{width: statusDetails.testBillingTotalToComplete > 0 ? 'calc(' + statusDetails.testBillingNumCompleted + '/' + statusDetails.testBillingTotalToComplete + '*100%)' : '2%'}}
                                                             aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"/>
                                                        ); })()}
                                                        <span style={{position: 'absolute', width: '100%', textAlign: 'center', fontSize: '0.75rem', lineHeight: '18px', top: 0, left: 0, color: 'white', textShadow: '0 0 3px rgba(0,0,0,0.6)', fontWeight: '600'}}>{statusDetails.testBillingTotalToComplete > 0 && statusDetails.testBillingNumCompleted === statusDetails.testBillingTotalToComplete ? 100 : statusDetails.testBillingPercentComplete}%</span>
                                                    </div>
                                                    <div className="d-flex flex-wrap justify-content-between" style={{gap: '0.25rem'}}>
                                                        <span className="badge badge-pill badge-light border text-muted">
                                                            <i className="fa fa-clock mr-1"/>Last Updated {statusDetails.testBillingLastUpdatedDate}ago
                                                        </span>
                                                        {statusDetails.testBillingTimeRemainingMessage != null && statusDetails.testBillingTotalToComplete > 0 &&
                                                            <span className="badge badge-pill badge-light border text-muted">
                                                                <i className="fa fa-hourglass-half mr-1"/>approximately {statusDetails.testBillingTimeRemainingMessage} remaining
                                                            </span>
                                                        }
                                                    </div>
                                                </>
                                            }
                                            {testBillingJobLogDisplayed && testBillingLogMessagesResponse &&
                                                <div style={{position: 'relative'}}>
                                                    <button onClick={() => this.handleCopyLogs('testBilling', testBillingLogMessagesResponse)} style={{position: 'absolute', top: '10px', right: '10px', zIndex: 1, background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: '#d4d4d4', borderRadius: '4px', padding: '2px 8px', fontSize: '0.72rem', cursor: 'pointer'}}>
                                                        {copiedSection === 'testBilling' ? <><i className="fa fa-check mr-1"/>Copied</> : <><i className="fa fa-copy mr-1"/>Copy</>}
                                                    </button>
                                                    <div className="cmv-container-log-viewer cmv-container-order-log-viewer mt-2" style={{backgroundColor: '#1e1e1e', color: '#d4d4d4', fontFamily: 'monospace', fontSize: '0.78rem', borderRadius: '6px', padding: '12px 16px', maxHeight: '200px', overflowY: 'auto', lineHeight: '1.6'}}>
                                                        {testBillingLogMessagesResponse.statusList.map((log) => <span key={log.id}>{log.stringVal}<br/></span>)}
                                                    </div>
                                                </div>
                                            }
                                        </>
                                    }
                                </div>

                                <div className="border rounded p-3 mb-3">
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <div className="d-flex align-items-center" style={{gap: '0.5rem'}}>
                                            <h6 className="mb-0 font-weight-bold">Billing Approval</h6>
                                            {statusDetails != null && statusDetails.billingApprovalTotalToComplete > 0 && statusDetails.billingApprovalNumCompleted === statusDetails.billingApprovalTotalToComplete &&
                                                <span className="badge badge-pill badge-success text-white" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600'}}><i className="fa fa-check mr-1"/>Completed</span>
                                            }
                                            {statusDetails != null && statusDetails.billingApprovalLastMessage == null && billingJob.status === 'APPROVEBILLING_SCHEDULED' &&
                                                <span className="badge badge-pill badge-primary text-white" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600'}}><i className="fa fa-calendar-alt mr-1"/>Scheduled</span>
                                            }
                                            {statusDetails != null && statusDetails.billingApprovalLastMessage != null && !(statusDetails.billingApprovalTotalToComplete > 0 && statusDetails.billingApprovalNumCompleted === statusDetails.billingApprovalTotalToComplete) && billingJob.status !== 'BILLING_FAILED' &&
                                                <span className="badge badge-pill text-dark" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600', backgroundColor: '#e0e0e0'}}><i className="fa fa-circle-notch fa-spin mr-1"/>In Progress</span>
                                            }
                                            {statusDetails != null && statusDetails.billingApprovalLastMessage != null && !(statusDetails.billingApprovalTotalToComplete > 0 && statusDetails.billingApprovalNumCompleted === statusDetails.billingApprovalTotalToComplete) && billingJob.status === 'BILLING_FAILED' &&
                                                <span className="badge badge-pill badge-danger text-white" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600'}}><i className="fa fa-times mr-1"/>Failed</span>
                                            }
                                        </div>
                                        {statusDetails != null && statusDetails.billingApprovalLastMessage != null &&
                                            <span title={billingApprovalJobLogDisplayed ? "Hide Approve Billing Log" : "Show Approve Billing Log"}>
                                                <Button onClick={this.handleShowBillingJobLog} className="btn btn-xs btn-order-log-toggle btn-billing-approval-log-display" onMouseLeave={(e) => e.currentTarget.blur()} type="button">
                                                    <i id="billingApprovalLogDisplaySelector" className="fas fa-list-ul"/>
                                                </Button>
                                            </span>
                                        }
                                    </div>
                                    {statusDetails == null &&
                                        <span className="badge badge-pill badge-light border text-muted">Not Started</span>
                                    }
                                    {statusDetails != null &&
                                        <>
                                            <p className="text-muted small mb-2">
                                                {statusDetails.billingApprovalLastMessage != null ? statusDetails.billingApprovalLastMessage : 'Not Started'}
                                            </p>
                                            {statusDetails.billingApprovalLastMessage != null &&
                                                <>
                                                    <div className="progress rounded-pill mb-1" style={{height: '18px', position: 'relative', ...(billingJob.status === 'BILLING_FAILED' && !(statusDetails.billingApprovalTotalToComplete > 0 && statusDetails.billingApprovalNumCompleted === statusDetails.billingApprovalTotalToComplete) && {backgroundColor: '#bd2130'})}}>
                                                        {(() => { const failed = billingJob.status === 'BILLING_FAILED' && statusDetails.billingApprovalLastMessage != null && !(statusDetails.billingApprovalTotalToComplete > 0 && statusDetails.billingApprovalNumCompleted === statusDetails.billingApprovalTotalToComplete); return (
                                                        <div className="progress-bar bg-success-with-pulse" role="progressbar"
                                                             style={{width: statusDetails.billingApprovalTotalToComplete > 0 ? 'calc(' + statusDetails.billingApprovalNumCompleted + '/' + statusDetails.billingApprovalTotalToComplete + '*100%)' : '2%', ...(failed && {backgroundColor: '#bd2130'})}}
                                                             aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"/>
                                                        ); })()}
                                                        <span style={{position: 'absolute', width: '100%', textAlign: 'center', fontSize: '0.75rem', lineHeight: '18px', top: 0, left: 0, color: 'white', textShadow: '0 0 3px rgba(0,0,0,0.6)', fontWeight: '600'}}>{statusDetails.billingApprovalTotalToComplete > 0 && statusDetails.billingApprovalNumCompleted === statusDetails.billingApprovalTotalToComplete ? 100 : statusDetails.billingApprovalPercentComplete}%</span>
                                                    </div>
                                                    <div className="d-flex flex-wrap justify-content-between" style={{gap: '0.25rem'}}>
                                                        <span className="badge badge-pill badge-light border text-muted">
                                                            <i className="fa fa-clock mr-1"/>Last Updated {statusDetails.billingApprovalLastUpdatedDate}ago
                                                        </span>
                                                        {statusDetails.billingApprovalTimeRemainingMessage != null && statusDetails.billingApprovalTotalToComplete > 0 &&
                                                            <span className="badge badge-pill badge-light border text-muted">
                                                                <i className="fa fa-hourglass-half mr-1"/>~{statusDetails.billingApprovalTimeRemainingMessage} remaining
                                                            </span>
                                                        }
                                                    </div>
                                                </>
                                            }
                                            {billingApprovalJobLogDisplayed && billingApprovalLogMessagesResponse &&
                                                <div style={{position: 'relative'}}>
                                                    <button onClick={() => this.handleCopyLogs('billingApproval', billingApprovalLogMessagesResponse)} style={{position: 'absolute', top: '10px', right: '10px', zIndex: 1, background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: '#d4d4d4', borderRadius: '4px', padding: '2px 8px', fontSize: '0.72rem', cursor: 'pointer'}}>
                                                        {copiedSection === 'billingApproval' ? <><i className="fa fa-check mr-1"/>Copied</> : <><i className="fa fa-copy mr-1"/>Copy</>}
                                                    </button>
                                                    <div className="cmv-container-log-viewer cmv-container-order-log-viewer mt-2" style={{backgroundColor: '#1e1e1e', color: '#d4d4d4', fontFamily: 'monospace', fontSize: '0.78rem', borderRadius: '6px', padding: '12px 16px', maxHeight: '200px', overflowY: 'auto', lineHeight: '1.6'}}>
                                                        {billingApprovalLogMessagesResponse.statusList.map((log) => <span key={log.id}>{log.stringVal}<br/></span>)}
                                                    </div>
                                                </div>
                                            }
                                        </>
                                    }
                                </div>

                                <div className="border rounded p-3 mb-3">
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <div className="d-flex align-items-center" style={{gap: '0.5rem'}}>
                                            <h6 className="mb-0 font-weight-bold">Invoice Generation</h6>
                                            {statusDetails != null && statusDetails.invoiceGenerationTotalToComplete > 0 && statusDetails.invoiceGenerationNumCompleted === statusDetails.invoiceGenerationTotalToComplete &&
                                                <span className="badge badge-pill badge-success text-white" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600'}}><i className="fa fa-check mr-1"/>Completed</span>
                                            }
                                            {statusDetails != null && statusDetails.invoiceGenerationLastMessage == null && billingJobDetail && billingJobDetail.generateScheduled &&
                                                <span className="badge badge-pill badge-primary text-white" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600'}}><i className="fa fa-calendar-alt mr-1"/>Scheduled</span>
                                            }
                                            {statusDetails != null && statusDetails.invoiceGenerationLastMessage != null && !(statusDetails.invoiceGenerationTotalToComplete > 0 && statusDetails.invoiceGenerationNumCompleted === statusDetails.invoiceGenerationTotalToComplete) && billingJob.status !== 'BILLING_FAILED' &&
                                                <span className="badge badge-pill text-dark" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600', backgroundColor: '#e0e0e0'}}><i className="fa fa-circle-notch fa-spin mr-1"/>In Progress</span>
                                            }
                                            {statusDetails != null && statusDetails.invoiceGenerationLastMessage != null && !(statusDetails.invoiceGenerationTotalToComplete > 0 && statusDetails.invoiceGenerationNumCompleted === statusDetails.invoiceGenerationTotalToComplete) && billingJob.status === 'BILLING_FAILED' &&
                                                <span className="badge badge-pill badge-danger text-white" style={{fontSize: '0.75rem', padding: '3px 8px', fontWeight: '600'}}><i className="fa fa-times mr-1"/>Failed</span>
                                            }
                                        </div>
                                        <div className="d-flex align-items-center" style={{gap: '0.25rem'}}>
                                            {statusDetails != null && statusDetails.invoiceGenerationLastMessage != null &&
                                                <span title={invoiceGenerationJobLogDisplayed ? "Hide Invoice Generation Log" : "Show Invoice Generation Log"}>
                                                    <Button onClick={this.handleShowBillingJobLog} className="btn btn-xs btn-order-log-toggle btn-invoice-generation-log-display" onMouseLeave={(e) => e.currentTarget.blur()} type="button">
                                                        <i id="invoiceGenerationLogDisplaySelector" className="fas fa-list-ul"/>
                                                    </Button>
                                                </span>
                                            }
                                        </div>
                                    </div>
                                    {statusDetails == null &&
                                        <span className="badge badge-pill badge-light border text-muted">Not Started</span>
                                    }
                                    {statusDetails != null &&
                                        <>
                                            <p className="text-muted small mb-2">
                                                {statusDetails.invoiceGenerationLastMessage != null ? statusDetails.invoiceGenerationLastMessage : 'Not Started'}
                                            </p>
                                            {statusDetails.invoiceGenerationLastMessage != null &&
                                                <>
                                                    <div className="progress rounded-pill mb-1" style={{height: '18px', position: 'relative', ...(billingJob.status === 'BILLING_FAILED' && !(statusDetails.invoiceGenerationTotalToComplete > 0 && statusDetails.invoiceGenerationNumCompleted === statusDetails.invoiceGenerationTotalToComplete) && {backgroundColor: '#bd2130'})}}>
                                                        {(() => { const failed = billingJob.status === 'BILLING_FAILED' && statusDetails.invoiceGenerationLastMessage != null && !(statusDetails.invoiceGenerationTotalToComplete > 0 && statusDetails.invoiceGenerationNumCompleted === statusDetails.invoiceGenerationTotalToComplete); return (
                                                        <div className={`progress-bar ${failed ? 'bg-danger' : 'bg-success-with-pulse'}`} role="progressbar"
                                                             style={{width: statusDetails.invoiceGenerationTotalToComplete > 0 ? 'calc(' + statusDetails.invoiceGenerationNumCompleted + '/' + statusDetails.invoiceGenerationTotalToComplete + '*100%)' : '2%'}}
                                                             aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"/>
                                                        ); })()}
                                                        <span style={{position: 'absolute', width: '100%', textAlign: 'center', fontSize: '0.75rem', lineHeight: '18px', top: 0, left: 0, color: 'white', textShadow: '0 0 3px rgba(0,0,0,0.6)', fontWeight: '600'}}>{statusDetails.invoiceGenerationTotalToComplete > 0 && statusDetails.invoiceGenerationNumCompleted === statusDetails.invoiceGenerationTotalToComplete ? 100 : statusDetails.invoiceGenerationPercentComplete}%</span>
                                                    </div>
                                                    <div className="d-flex flex-wrap justify-content-between" style={{gap: '0.25rem'}}>
                                                        <span className="badge badge-pill badge-light border text-muted">
                                                            <i className="fa fa-clock mr-1"/>Last Updated {statusDetails.invoiceGenerationLastUpdatedDate} ago
                                                        </span>
                                                        {statusDetails.invoiceGenerationTimeRemainingMessage != null && statusDetails.invoiceGenerationTotalToComplete > 0 &&
                                                            <span className="badge badge-pill badge-light border text-muted">
                                                                <i className="fa fa-hourglass-half mr-1"/>~{statusDetails.invoiceGenerationTimeRemainingMessage} remaining
                                                            </span>
                                                        }
                                                    </div>
                                                </>
                                            }
                                            {invoiceGenerationJobLogDisplayed && invoiceGenerationLogMessagesResponse &&
                                                <div style={{position: 'relative'}}>
                                                    <button onClick={() => this.handleCopyLogs('invoiceGeneration', invoiceGenerationLogMessagesResponse)} style={{position: 'absolute', top: '10px', right: '10px', zIndex: 1, background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: '#d4d4d4', borderRadius: '4px', padding: '2px 8px', fontSize: '0.72rem', cursor: 'pointer'}}>
                                                        {copiedSection === 'invoiceGeneration' ? <><i className="fa fa-check mr-1"/>Copied</> : <><i className="fa fa-copy mr-1"/>Copy</>}
                                                    </button>
                                                    <div className="cmv-container-log-viewer cmv-container-order-log-viewer mt-2" style={{backgroundColor: '#1e1e1e', color: '#d4d4d4', fontFamily: 'monospace', fontSize: '0.78rem', borderRadius: '6px', padding: '12px 16px', maxHeight: '200px', overflowY: 'auto', lineHeight: '1.6'}}>
                                                        {invoiceGenerationLogMessagesResponse.statusList.map((log) => <span key={log.id}>{log.stringVal}<br/></span>)}
                                                    </div>
                                                </div>
                                            }
                                        </>
                                    }
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button onClick={this.closeModal} className="btn btn-secondary rounded-pill px-4">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop show" tabIndex="1" />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const modalProps = getModalData(state).modalProps;
    return {
        modalProps,
        canApproveBilling: getUserPermission(state, 'OPER', 'OPER_BILLING_APPROVE'),
        canRejectBilling: getUserPermission(state, 'OPER', 'OPER_BILLING_REJECT'),
        canGenerateInvoices: getUserPermission(state, 'OPER', 'OPER_BILLING_GENERATE'),
    };
};

const mapDispatchToProps = {
    loadBillingJob,
    loadBillingJobStatusSummary,
    loadBillingJobStatusDetails,
    loadBillingJobAssessment,
    hideModal,
    showModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingJobMonitorModal);

